import React from "react";

import HeroSection from "../../../hero-section";
import DesktopList from "./desktop";
import MobileList from "./mobile";

const FeaturesList = () => (
  <div className="bg-gradient-to-tr from-navy-dark to-primary">
    <HeroSection>
      <div className="w-full">
        <DesktopList />
        <MobileList />
      </div>
    </HeroSection>
  </div>
);

export default FeaturesList;
